





























































import InvoicePartyForm from "@/components/invoice/InvoicePartyForm.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import RefsRepairEstimateRequest from "@/components/utility/RefsRepairEstimateRequest.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Reference } from "@/models/reference.entity";
import { IRepairEstimateRequest } from "@/models/repair-estimate-request.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import { ActivityLog } from "@/models/activity-log.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import RefsSelect from "@/components/utility/RefsSelect.vue";

export enum RepairEstimateSteps {
  SELLER = "seller",
  EXPIRATION = "expiration",
  SEND_MAIL = "sendMail",
  SUCCESS = "success"
}

@Component({
  components: { InvoicePartyForm, PreselectTemplateCard, RefsRepairEstimateRequest, RefsSelect },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RepairEstimateRequestCreateStepper extends mixins(PermissionMixin) {
  readonly RepairEstimateSteps = RepairEstimateSteps;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop()
  value!: IRepairEstimateRequest;

  @Prop()
  step!: RepairEstimateSteps;

  @Prop({ default: false })
  hideRefsSelect!: boolean;

  sharedContent: ISharedContent = new SharedContent({ partnerId: this.value.partnerId });

  requestsLoading = false;

  get categories(): BackendResourceEnum[] {
    return [BackendResourceEnum.REPORT];
  }

  get stepLocal() {
    return this.step;
  }

  set stepLocal(step: RepairEstimateSteps) {
    this.$emit("update:step", step);
  }

  get templateRefs() {
    return [...this.value.refs, { refId: this.value.id, refType: ResourceEnum.REPAIR_ESTIMATE_REQUEST }];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get context() {
    return {
      repairEstimate: this.value,
      sharedContent: this.sharedContent,
      partner: this.partner,
      url: { sharing: this.sharedContent.url }
    };
  }

  async createRequests() {
    this.requestsLoading = true;
    try {
      if (!this.value.id) {
        await this.value.create();

        if (this.value.id) {
          for (const ref of this.value.refs) {
            await new ActivityLog({
              partnerId: this.value.partnerId,
              target: [{ refId: this.value.id, refType: ResourceEnum.REPAIR_ESTIMATE_REQUEST }],
              actionType: ActionEnum.CREATE,
              activity: ActivityTypeEnum.CREATE_REF,
              source: ref
            })
              .create()
              .catch(this.$log.error);
          }
        }
      }

      this.sharedContent.refs = [...this.value.refs];
      if (this.value.id) {
        this.sharedContent.refs.push(
          new Reference({ refId: this.value.id, refType: ResourceEnum.REPAIR_ESTIMATE_REQUEST })
        );
      } else {
        throw new Error("Repair estimate request ID is not defined");
      }

      await this.sharedContent.create();
      this.$emit("create:sharedContent", this.sharedContent);
      this.stepLocal = RepairEstimateSteps.SEND_MAIL;
    } catch (e) {
      handleError(e);
    }
    this.requestsLoading = false;
  }
}
